
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate/blogs/[...slug]",
      function () {
        return require("private-next-pages/corporate/blogs/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate/blogs/[...slug]"])
      });
    }
  